import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onewaycabpune() {



const cardData = {
  keyword: " One Way Cab Pune  ",

"headingDescription": "SRS Cab Service offers One Way Cab Pune, providing a cost-effective, comfortable, and hassle-free travel solution for travelers looking for single-trip rides without return charges. Our well-maintained vehicles, professional drivers, and timely pickups ensure a smooth and reliable journey across Pune and to outstation destinations. Ideal for airport transfers, intercity travel, and business trips, SRS Cab Service delivers flexible booking options, transparent pricing, and 24/7 customer support for a convenient one-way travel experience.",
"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is a historic fort and one of Pune’s most iconic landmarks. Travelers using One Way Cab Pune from SRS Cab Service often visit this site to explore its grand architecture and historical significance."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a prominent historical monument associated with India’s freedom movement. Visitors using One Way Cab Pune from SRS Cab Service often explore its beautiful gardens and museum exhibits."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is a popular hill fort known for its scenic views and trekking routes. Travelers using One Way Cab Pune from SRS Cab Service often include this destination for adventure and sightseeing."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Dagdusheth Halwai Ganpati Temple is one of Pune’s most revered religious sites. Visitors using One Way Cab Pune from SRS Cab Service often stop here to seek blessings and experience spiritual serenity."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an ancient rock-cut temple dedicated to Lord Shiva. Travelers using One Way Cab Pune from SRS Cab Service enjoy its peaceful ambiance and historic architecture."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses an extensive collection of Indian artifacts. Visitors using One Way Cab Pune from SRS Cab Service explore Pune’s cultural heritage here."
  },
  {
    "title": "Parvati Hill Temple",
    "description": "Parvati Hill Temple offers panoramic views of Pune along with historic temples. Travelers using One Way Cab Pune from SRS Cab Service often climb the hill for sightseeing and relaxation."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam is a peaceful destination surrounded by scenic beauty. Visitors using One Way Cab Pune from SRS Cab Service often include this spot for relaxation and photography."
  },
  {
    "title": "Pune Okayama Friendship Garden",
    "description": "Pune Okayama Friendship Garden is a beautifully designed Japanese-style garden. Travelers using One Way Cab Pune from SRS Cab Service enjoy its greenery and calm environment."
  },
  {
    "title": "Lal Mahal",
    "description": "Lal Mahal is a historic palace associated with Chhatrapati Shivaji Maharaj. Visitors using One Way Cab Pune from SRS Cab Service often explore this landmark to understand Pune’s rich history."
  }
],



services: [
{
name: "Pune to Shirdi Cab One Way",
description: "Pune to Shirdi cab one way offers economical travel without return charges. Customers can book direct rides for temple visits. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily to Shirdi with one way cab services."
},
{
name: "One Way Cab Pune to Mumbai",
description: "One way cab Pune to Mumbai provides convenient travel for single-direction journeys. Customers can book cabs for business and airport travel. Professional drivers ensure safe highway journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one way cab services."
},
{
name: "One Way Cab Pune",
description: "One way cab Pune offers flexible travel solutions for multiple destinations. Customers can book cabs without return charges. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one way cab services in Pune."
},
{
name: "One Way Cab Mumbai to Pune",
description: "One way cab Mumbai to Pune provides convenient intercity travel. Customers can book cabs for direct drop services. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one way cab services."
},
{
name: "Mumbai Pune Cab One Way",
description: "Mumbai Pune cab one way offers direct transportation between cities. Customers can book cabs for quick and comfortable travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one way cab services."
},
{
name: "Pune to Aurangabad Cab One Way",
description: "Pune to Aurangabad cab one way provides economical travel for direct trips. Customers can book cabs without return charges. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one way cab services."
},
{
name: "Pune to Mumbai Taxi One Way",
description: "Pune to Mumbai taxi one way offers convenient travel for single-direction journeys. Customers can book taxis for flexible travel plans. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one way taxi services."
},
{
name: "One Way Taxi Mumbai to Pune",
description: "One way taxi Mumbai to Pune provides reliable transportation for direct trips. Customers can book taxis for quick journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one way taxi services."
},
{
name: "One Way Taxi from Shirdi to Pune",
description: "One way taxi from Shirdi to Pune offers comfortable travel for return journeys. Customers can book taxis for direct drop services. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one way taxi services."
},
{
name: "One Way Cab from Pune to Kolhapur",
description: "One way cab from Pune to Kolhapur provides convenient travel for long-distance trips. Customers can book cabs for direct journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one way cab services."
},
{
name: "One Way Cab from Pune to Mahabaleshwar",
description: "One way cab from Pune to Mahabaleshwar offers comfortable travel for hill station visits. Customers can book cabs for scenic trips. Professional drivers ensure safe ghat road journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one way cab services."
},
{
name: "One Way Cab Pune to Aurangabad",
description: "One way cab Pune to Aurangabad provides economical travel for direct journeys. Customers can book cabs without return charges. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one way cab services."
},
{
name: "One Way Car Rental Pune",
description: "One way car rental Pune offers flexible travel options for multiple destinations. Customers can rent cars for single-direction trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one way car rental services."
},
{
name: "One Way Drop Taxi Pune",
description: "One way drop taxi Pune provides direct transportation services for travelers. Customers can book taxis for convenient drop journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with drop taxi services."
},
{
name: "One Way Mumbai to Pune",
description: "One way Mumbai to Pune offers convenient intercity travel for passengers. Customers can book cabs for direct trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one way travel services."
},
{
name: "Pune to Aurangabad One Way Taxi",
description: "Pune to Aurangabad one way taxi provides economical travel without return charges. Customers can book taxis for direct journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one way taxi services."
},
{
name: "Pune to Goa One Way Cab",
description: "Pune to Goa one way cab offers comfortable long-distance travel for vacations. Customers can book cabs for beach trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one way cab services."
},
{
name: "Pune to Goa One Way Taxi",
description: "Pune to Goa one way taxi provides convenient travel for single-direction trips. Customers can book taxis for flexible travel plans. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one way taxi services."
},
{
name: "Pune to Goa Taxi Fare One Way",
description: "Pune to Goa taxi fare one way provides estimated pricing for travel planning. Customers can compare fares before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with taxi fare services."
},
{
name: "Pune to Kolhapur One Way Cab",
description: "Pune to Kolhapur one way cab offers economical travel for direct journeys. Customers can book cabs without return charges. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one way cab services."
},
{
name: "Pune to Mahabaleshwar One Way Cab",
description: "Pune to Mahabaleshwar one way cab provides comfortable travel for hill station trips. Customers can book cabs for scenic journeys. Professional drivers ensure safe ghat road travel. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one way cab services."
}
],

tableData: [
["Pune to Shirdi Cab One Way","One Way Cab Pune to Mumbai"],
["One Way Cab Pune","One Way Cab Mumbai to Pune"],
["Mumbai Pune Cab One Way","Pune to Aurangabad Cab One Way"],
["Pune to Mumbai Taxi One Way","One Way Taxi Mumbai to Pune"],
["One Way Taxi from Shirdi to Pune","One Way Cab from Pune to Kolhapur"],
["One Way Cab from Pune to Mahabaleshwar","One Way Cab Pune to Aurangabad"],
["One Way Car Rental Pune","One Way Drop Taxi Pune"],
["One Way Mumbai to Pune","Pune to Aurangabad One Way Taxi"],
["Pune to Goa One Way Cab","Pune to Goa One Way Taxi"],
["Pune to Goa Taxi Fare One Way","Pune to Kolhapur One Way Cab"],
["Pune to Mahabaleshwar One Way Cab","One Way Cab Pune"]
],



whychoose: [
  {
    WhyChooseheading: "Cheapest One Way Cab in Pune",
    WhyChoosedescription: "SRS Cab Service offers the most affordable one way cab Pune service where you pay only for single-side travel without return fare, making it highly cost-effective."
  },
  {
    WhyChooseheading: "Wide Coverage Across Cities",
    WhyChoosedescription: "We provide one way cab service from Pune to Mumbai, Nashik, Shirdi, Lonavala, Goa, Kolhapur, and many other popular destinations across India."
  },
  {
    WhyChooseheading: "24/7 One Way Cab Booking",
    WhyChoosedescription: "SRS Cab Service operates 24/7, allowing you to book one way cabs anytime for business trips, airport transfers, or emergency travel."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles",
    WhyChoosedescription: "Our fleet includes clean, well-maintained, and air-conditioned cars to ensure a comfortable and smooth one way journey."
  },
  {
    WhyChooseheading: "Multiple Cab Options Available",
    WhyChoosedescription: "Choose from hatchback, sedan, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers based on your travel needs and budget."
  },
  {
    WhyChooseheading: "Doorstep Pickup Anywhere in Pune",
    WhyChoosedescription: "We provide pickup from homes, hotels, offices, and Pune Airport across all locations including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
  },
  {
    WhyChooseheading: "Safe & Professional Drivers",
    WhyChoosedescription: "Our experienced drivers ensure safe driving, route expertise, and smooth travel for all one way journeys from Pune."
  },
  {
    WhyChooseheading: "Trusted One Way Cab Service Provider",
    WhyChoosedescription: "SRS Cab Service is trusted by customers for one way cab Pune bookings due to affordable pricing, reliability, and excellent service quality."
  }
]
}

const faqData = [
  { question: "Do you provide one way cab service in Pune?", answer: "Yes, SRS Cab Service offers reliable one way cab service from Pune to various cities." },
  { question: "What is one way cab Pune service?", answer: "One way cab service allows you to travel to your destination without paying return charges, making it cheaper than round trips." },
  { question: "Which destinations are available for one way cab?", answer: "Popular routes include Pune to Mumbai, Shirdi, Nashik, Goa, Lonavala, Kolhapur, and more." },
  { question: "Is one way cab service available 24/7?", answer: "Yes, our one way cab service operates 24 hours a day." },
  { question: "Which vehicles are available for one way travel?", answer: "We offer hatchback, sedan, SUVs, Innova Crysta, and Tempo Travellers." },
  { question: "Is one way cab cheaper than round trip?", answer: "Yes, one way cab is more affordable as you only pay for one-side travel." },
  { question: "Can I book one way cab online?", answer: "Yes, you can easily book one way cab Pune service online or via phone." },
  { question: "Do you provide one way airport transfers?", answer: "Yes, we provide one way cab service from Pune to Mumbai Airport and other airports." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from homes, hotels, offices, and Pune Airport." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sagar Patil",
    feedback:
      "Booked one way cab Pune to Nashik. Very affordable and smooth service.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Riya Sharma",
    feedback:
      "Best one way cab service in Pune. Clean car, on-time pickup, and great experience.",
    rating: 5
  }
];




























const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];









const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "One Way Cab Pune | SRS Cab",
  "description": "Book one-way cab services from Pune with SRS Cab. Travel from Pune to Mumbai, Shirdi, Aurangabad, Kolhapur, Mahabaleshwar, and more. Comfortable Innova, Sedan, and Tempo Traveller options. Affordable and reliable one-way taxi service with 24x7 booking.",
  "brand": {
    "@type": "Brand",
    "name": "SRS Cab"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.srscabservice.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1980"
  }
};









  return (
    <div>
      

<Helmet>
  <title>One Way Cab Pune | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="SRS Cab offers one-way cab services from Pune to Shirdi, Mumbai, Aurangabad, Kolhapur, Mahabaleshwar, and more. Travel comfortably with Innova, Sedan, or Tempo Traveller. Affordable, reliable, 24x7 booking." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/47.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Onewaycabpune;